<a class="skip-link" href="#main" (click)="skipToMainContent($event)">{{
  'Skip to main content' | ai: 'SKIP_LINK_TEXT' | async
}}</a>

<mat-sidenav-container [ngClass]="{ 'game-menu': appSettings.layout.gameMenu === true }">
  <div id="app-main-content">
    <div id="wrapper">
      <div class="content-wrapper" [class.nav-side-buttons]="hasNavSideButtons()">
        @if (appSettings.layout.gameMenu) {
          <button
            mat-icon-button
            class="navbar-button mat-icon-button mat-grey-100-bg"
            matSidenavToggler="game-menu"
            [attr.aria-label]="'Open navigation menu' | ai: 'ARIA_OPEN_NAV_MENU' | async"
            [attr.aria-expanded]="isNavOpen"
            aria-controls="game-menu-nav">
            <mat-icon aria-hidden="true">menu</mat-icon>
          </button>
        }

        <!-- <app-achievement *ngIf="showAchievement" (hide)="showAchievement=null;" [achievement]="showAchievement.achievement" [reward]="showAchievement.reward" [progress]="showAchievement.progress" [settingsChanges]="appConfig.onSettingsChanged" ></app-achievement> -->

        <!-- <app-progress-bar *ngIf="appSettings.layout.gameProgress"></app-progress-bar> -->

        @if (appSettings.layout.toolbar === 'below') {
          <app-toolbar class="below"></app-toolbar>
        }

        <app-feature-modules id="app-feature"></app-feature-modules>

        @if (appSettings.layout.footer === 'below') {
          @if (isShowFooter) {
            <app-footer class="below"></app-footer>
          }
        }

        <router-outlet name="program-popup"></router-outlet>
      </div>
    </div>
  </div>

  @if (appSettings.layout.gameMenu === true) {
    <mat-sidenav
      id="game-menu-nav"
      matSidenavHelper="game-menu"
      class="game-menu"
      [restoreFocus]="false"
      [attr.aria-label]="'Navigation menu' | ai: 'ARIA_NAV_MENU' | async"
      (closedStart)="onNavClosed()"
      (opened)="onNavOpened()"
      (openedChange)="isNavOpen = $event">
      <app-navigation></app-navigation>
    </mat-sidenav>
  }
</mat-sidenav-container>

<div aria-live="polite" aria-atomic="true">
  @if (hintService.isShowHint) {
    <app-hint></app-hint>
  }
</div>

<router-outlet class="popup" name="popup"></router-outlet>
